import { render, staticRenderFns } from "./JournalFilesView.vue?vue&type=template&id=9c29e150&scoped=true&"
import script from "./JournalFilesView.vue?vue&type=script&lang=ts&"
export * from "./JournalFilesView.vue?vue&type=script&lang=ts&"
import style0 from "./JournalFilesView.vue?vue&type=style&index=0&id=9c29e150&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c29e150",
  null
  
)

export default component.exports